import Pikaday from 'pikaday';

var picker = new Pikaday( {
  field: document.getElementById('date-input'),
  minDate: new Date(),
} );